<template>
  <section class="app-main">
    <div class="top-bar top-flex">
      <el-button
        type="primary"
        @click="$router.go(-1)"
        style="margin-right: 30px; width: 135px"
      >
        <i class="el-icon-d-arrow-left"></i>
        返回列表
      </el-button>

      <el-button type="warning" @click="onOrder()" style="width: 135px"
        >打印订单详情</el-button
      >

      <el-button
        type="primary"
        :disabled="disabled"
        @click="onPrint()"
        style="margin-left: 30px; width: 135px"
      >
        查看运单
        <i class="el-icon-tickets el-icon--right"></i>
      </el-button>
    </div>

    <el-card class="m-bottom-4" style="position: relative;">
      <el-row class="m-bottom-2">
        <el-col :span="11" class="row-height"
          >订单号码：{{ detail.title }}</el-col
        >
        <el-col :span="13" class="row-height"
          >下单时间：{{ detail.updated_at }}</el-col
        >
      </el-row>
      <el-row class="m-bottom-2">
        <el-col :span="11" class="row-height"
          >下单账号：{{
            detail.phone != "" ? detail.phone : (detail.email!=''?detail.email:(detail.order_logistics.tel!=''?detail.order_logistics.tel : detail.order_logistics.email))
          }}</el-col
        >
        <el-col :span="13" class="row-height"
          >收货方式：{{ detail.delivery_method_title }}</el-col
        >
      </el-row>
      <el-row class="row-height" v-if="detail.delivery_method == 1"
        >取 件 码 ：{{ detail.order_logistics.pick_up_code }}</el-row
      >
      <el-row
        class="row-height"
        v-if="detail.delivery_method == 0 && detail.order_logistics"
         style="padding-right:36px;"
      >
        地址详情：{{
          detail.order_logistics.surname +
          "  " +
          detail.order_logistics.name +
          "  " +
          detail.order_logistics.tel +
          ", " +
          detail.order_logistics.address +
          ", " +
          (detail.order_logistics.city_arr ? detail.order_logistics.city_arr.ename : detail.order_logistics.city_name) +
          ", " +
          detail.order_logistics.province_arr.abbreviation +
          ", " +
          detail.order_logistics.country_arr.ename +
          ", " +
          detail.order_logistics.zipcode
        }}
      </el-row>
      <el-row class="remarks">
        <div class="remarks-inp">
            <span>备注：</span> 
            <el-input ref="input" type="textarea" v-model="detail.remarks" :rows="4" resize="none" disabled></el-input>
          </div>
      </el-row>
    </el-card>

    <el-card class="m-bottom-4">
      <el-table
        :data="detail.order_goods"
        max-height="360px"
        class="m-bottom-4"
      >
        <el-table-column label="图片" align="center">
          <template slot-scope="scope">
            <m-img :src="scope.row.goods_sku_pic_url" />
          </template>
        </el-table-column>
        <el-table-column
          prop="goods_name"
          align="center"
          label="商品名称"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="sku_name"
          align="center"
          label="商品规格"
        ></el-table-column>
        <el-table-column
          prop="barcode"
          align="center"
          label="条形码"
        ></el-table-column>
        <el-table-column
          prop="goods_number"
          align="center"
          label="商品数量"
        ></el-table-column>
        <el-table-column
          prop="after_sale_number"
          align="center"
          label="退货数量"
        ></el-table-column>
        <el-table-column
          prop="goods_price"
          align="center"
          label="商品价格"
        >
          <template slot-scope="scope">
            {{detail.order_logistics.country == 507 ? 'US$':'C$'}}{{scope.row.goods_price}}
          </template>
      </el-table-column>
      </el-table>
      <el-row class="row-height">
        <span class="row-span">商品总价：{{detail.order_logistics.country == 507 ? 'US$':'C$'}}{{ detail.goods_amount }} </span>
        <span class="row-span">钱包抵扣：{{detail.order_logistics.country == 507 ? 'US$':'C$'}}{{ detail.goods_wallet_fee }} </span>
        <span class="row-span">优惠金额：{{detail.order_logistics.country == 507 ? 'US$':'C$'}}{{ detail.goods_discount_fee }} </span>
        <span class="row-span" v-if="detail.pst_amount != '0.00'"
          >PST：{{detail.order_logistics.country == 507 ? 'US$':'C$'}}{{ detail.pst_amount }}
        </span>
        <span class="row-span" v-if="detail.gst_amount != '0.00'"
          >GST：{{detail.order_logistics.country == 507 ? 'US$':'C$'}}{{ detail.gst_amount }}
        </span>
        <span class="row-span" v-if="detail.hst_amount != '0.00'"
          >HST：{{detail.order_logistics.country == 507 ? 'US$':'C$'}}{{ detail.hst_amount }}
        </span>
        <span class="row-span" v-if="detail.qst_amount != '0.00'"
          >QST：{{detail.order_logistics.country == 507 ? 'US$':'C$'}}{{ detail.qst_amount }}
        </span>
        <span class="row-span">运费：{{detail.order_logistics.country == 507 ? 'US$':'C$'}}{{ detail.shipping_fee }}</span>
        <span class="row-span" style="font-weight: bold"
          >支付总价：{{detail.order_logistics.country == 507 ? 'US$':'C$'}}{{ detail.order_total_amount }}</span
        >
      </el-row>
    </el-card>

    <el-card class="m-bottom-4">
      <el-row class="m-bottom-4 row-height" v-if="detail.delivery_method == 0">
        <el-col :span="2" class="col-label">选择物流：</el-col>
        <el-col :span="21">
          <el-radio-group v-model="delivery_method">
            <el-radio :label="1" border>MOOBYYOHO</el-radio>
            <el-radio :label="2" border>eShipper</el-radio>
            <el-radio :label="3" border>其他</el-radio>
          </el-radio-group>
        </el-col>
      </el-row>
      <el-row class="m-bottom-4 row-height" v-if="detail.delivery_method == 1">
        <el-col :span="2" class="col-label">选择物流：</el-col>
        <el-col :span="4">
          <el-radio-group v-model="delivery_method">
            <el-radio :label="5" border>自提</el-radio>
          </el-radio-group>
        </el-col>
        <el-col :span="2" class="col-label">确定物流：</el-col>
        <el-col :span="5">
          <el-button
            type="success"
            :disabled="disabled"
            @click="onConfirm()"
            style="width: 135px"
            >确认订单物流</el-button
          >
        </el-col>
        <!-- <el-col :span="4">
          <el-button
            type="danger"
            :disabled="disabled"
            @click="resetConfirm()"
            style="width: 135px"
            >重置订单物流</el-button
          >
        </el-col> -->
      </el-row>
      <el-row class="m-bottom-4 row-height" v-show="delivery_method == 1">
        <el-col :span="2" class="col-label">物流公司：</el-col>
        <el-col :span="21">
          <span
            style="width: 300px"
          >MOOBYYOHO</span>
        </el-col>
      </el-row>
      <el-row class="m-bottom-4 row-height" v-show="delivery_method == 2">
        <el-col :span="2" class="col-label">物流公司：</el-col>
        <el-col :span="21">
          <el-col :span="21">
          <span
            style="width: 300px"
          >{{detail.order_logistics.carrier_name}}</span>
        </el-col>
        </el-col>
      </el-row>
      <el-row class="m-bottom-4 row-height"  v-show="delivery_method != 5">   
        <el-col :span="2" class="col-label">推荐箱规：</el-col>
        <el-col :span="21">
          <span
            style="width: 300px"
          >{{detail.order_logistics.packing + ' (cm)'}}</span>
        </el-col>
      </el-row>

      <el-row class="m-bottom-4 row-height"  v-show="delivery_method == 2">   
        <el-col :span="2" class="col-label">运费价格：</el-col>
        <el-col :span="21">
          <span
            style="width: 300px"
          >{{freight_price}} (C$)</span>
        </el-col>
      </el-row>

      <el-row class="m-bottom-4 row-height"  v-show="delivery_method != 5">
        <el-col :span="2" class="col-label">订单重量：</el-col>
        <el-col :span="21">
          <span
            style="width: 300px"
          >{{detail.order_logistics.weight + ' (kg)'}}</span>
        </el-col>
      </el-row>

      <el-row class="m-bottom-4 row-height" v-show="delivery_method == 3">
        <el-col :span="2" class="col-label">物流单号：</el-col>
        <el-col :span="21">
          <el-input
            v-model="carrier_number"
            placeholder="请输入物流单号"
            style="width: 300px"
          ></el-input>
        </el-col>
      </el-row>
      <el-row class="m-bottom-4 row-height" v-show="delivery_method == 3">
        <el-col :span="2" class="col-label">物流名称：</el-col>
        <el-col :span="21">
          <el-input
            v-model="carrier_name"
            placeholder="请输入物流名称"
            style="width: 300px"
          ></el-input>
        </el-col>
      </el-row>
      <el-row class="m-bottom-4 row-height" v-show="delivery_method == 3">
        <el-col :span="2" class="col-label">物流费用：</el-col>
        <el-col :span="21">
          <el-input
            v-model="freight"
            placeholder="请输入物流费用"
            style="width: 300px"
          ></el-input>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="2" class="col-label">物流备注（{{detail.lang == 'zh' ? '中': '英'}}）：</el-col>
        <el-col :span="21">
          <el-input 
          type="textarea" 
          placeholder="请输入物流备注" 
          :rows="4"
          resize="none"
          style="width: 300px"
          v-model="logisticsRemarks" >
        </el-input>
        </el-col>
      </el-row>
    </el-card>

    <el-card v-if="detail.delivery_method != 1">
      <el-row class="row-height">
        <el-col :span="2" class="col-label">确定物流：</el-col>
        <el-col :span="3" style="min-width:100px;">
          <el-button
            type="success"
            :disabled="disabled"
            @click="onConfirm()"
            style="width: 135px"
            >确认订单物流</el-button
          >
        </el-col>
         <el-col :span="4" style="min-width:100px;">
          <el-button
            type="danger"
            :disabled="disabled"
            @click="resetConfirm()"
            style="width: 135px"
            >重置订单物流</el-button
          >
        </el-col>
      </el-row>
    </el-card>

    <!-- 订单详情图片弹窗 -->
    <el-dialog :visible.sync="orderModel" width="800px">
      <el-card>
        <div class="order-detail">
          <div
            id="order"
            ref="print"
            style="
              width: 100%;
              min-height: 1016px;
              box-sizing: border-box;
              padding: 0 20px;
              position: relative;
            "
          >
              <div
              style="
                height: 40px;
                line-height: 40px;
                font-weight: 600;
                text-align: center;
                margin-top: 20px;
                background-color: #eee;
              "
            >
              Packing Slip for Order {{ detail.title }}
            </div>
            <div>
              <img
                style="width: 70px; height: 70px"
                src="data:image/png;base64,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"
                alt=""
              />
            </div>
            <p style="font-size: 16px">MOOBYYOHO.COM</p>
            <table
              class="f_table"
              border="1"
              style="width: 100%; border-collapse: collapse; border: none;page-break-inside : avoid;"
            >
              <tr>
                <td style="padding-left: 5px; font-size: 14px; border: none">
                  Unit 133-11121 Horseshoe Way
                </td>
                <td
                  style="
                    padding-left: 5px;
                    font-size: 14px;
                    width: 100px;
                    font-weight: bold;
                    border: none;
                  "
                >
                  Order ID:
                </td>
                <td
                  style="
                    padding-left: 5px;
                    font-size: 14px;
                    width: 200px;
                    border: none;
                  "
                >
                  {{ detail.title }}
                </td>
              </tr>
              <tr>
                <td style="padding-left: 5px; font-size: 14px; border: none">
                  Richmond, BC V7A 5G7
                </td>
                <td
                  style="
                    padding-left: 5px;
                    font-size: 14px;
                    width: 100px;
                    font-weight: bold;
                    border: none;
                  "
                >
                  Order Date:
                </td>
                <td
                  style="
                    padding-left: 5px;
                    font-size: 14px;
                    width: 200px;
                    border: none;
                  "
                >
                  {{ detail.updated_at }}
                </td>
              </tr>
              <tr>
                <td style="padding-left: 5px; font-size: 14px; border: none">
                  CA
                </td>
                <td
                  style="
                    padding-left: 5px;
                    font-size: 14px;
                    width: 100px;
                    font-weight: bold;
                    border: none;
                  "
                >
                 <span  v-if="detail.delivery_method == 0">
                  Shipping Via
                 </span>
                </td>
                <td
                  style="
                    padding-left: 5px;
                    font-size: 14px;
                    width: 200px;
                    border: none;
                  "
                  
                >
                <span  v-if="detail.delivery_method == 0">
                  {{detail.order_logistics.carrier_name}}
                </span>
                </td>
              </tr>
              <tr>
                <td
                  style="padding-left: 5px; font-size: 14px; border: none"
                ></td>
                <td
                  style="
                    padding-left: 5px;
                    font-size: 14px;
                    width: 100px;
                    font-weight: bold;
                    border: none;
                  "
                >
                <span  v-if="detail.delivery_method == 0">
                  Tracking No:
                </span>
                </td>
                <td
                  style="
                    padding-left: 5px;
                    font-size: 14px;
                    width: 200px;
                    border: none;
                  "
                >
                 <span  v-if="detail.delivery_method == 0">
                  {{detail.order_logistics.carrier_number}}
                 </span>
                </td>
              </tr>
              <tr style="height: 35px; font-weight: bold">
                <td style="padding-left: 5px; font-size: 14px; border: none">
                  Ship To:
                </td>
                <td
                  style="
                    padding-left: 5px;
                    font-size: 14px;
                    width: 100px;
                    font-weight: bold;
                    border: none;
                  "
                ></td>
                <td
                  style="
                    padding-left: 5px;
                    font-size: 14px;
                    width: 200px;
                    border: none;
                  "
                ></td>
              </tr>
              <tr>
                <td style="padding-left: 5px; font-size: 14px; border: none">
                  {{detail.order_logistics.surname}} {{detail.order_logistics.name}}
                </td>
                <td
                  style="
                    padding-left: 5px;
                    font-size: 14px;
                    width: 100px;
                    font-weight: bold;
                    border: none;
                  "
                ></td>
                <td
                  style="
                    padding-left: 5px;
                    font-size: 14px;
                    width: 200px;
                    border: none;
                  "
                ></td>
              </tr>
              <tr>
                <td style="padding-left: 5px; font-size: 14px; border: none">
                   <span  v-if="detail.delivery_method == 0">
                  {{detail.order_logistics.address}}       
                   </span>
                </td>
                <td
                  style="
                    padding-left: 5px;
                    font-size: 14px;
                    width: 100px;
                    font-weight: bold;
                    border: none;
                  "
                ></td>
                <td
                  style="
                    padding-left: 5px;
                    font-size: 14px;
                    width: 200px;
                    border: none;
                  "
                ></td>
              </tr>
              <tr>
                <td style="padding-left: 5px; font-size: 14px; border: none" >
                  <span v-if="detail.delivery_method == 0">
                    {{(detail.order_logistics.city_arr ? detail.order_logistics.city_arr.ename : detail.order_logistics.city_name) +", " +detail.order_logistics.province_arr.abbreviation +", " +detail.order_logistics.country_arr.ename}}
                  </span>
                  
                </td>
                <td
                  style="
                    padding-left: 5px;
                    font-size: 14px;
                    width: 100px;
                    font-weight: bold;
                    border: none;
                  "
                ></td>
                <td
                  style="
                    padding-left: 5px;
                    font-size: 14px;
                    width: 200px;
                    border: none;
                  "
                ></td>
              </tr>
              <tr>
                <td style="padding-left: 5px; font-size: 14px; border: none">
                  <span  v-if="detail.delivery_method == 0">
                  {{detail.order_logistics.zipcode}}
                  </span>
                </td>
                <td
                  style="
                    padding-left: 5px;
                    font-size: 14px;
                    width: 100px;
                    font-weight: bold;
                    border: none;
                  "
                ></td>
                <td
                  style="
                    padding-left: 5px;
                    font-size: 14px;
                    width: 200px;
                    border: none;
                  "
                ></td>
              </tr>
            </table>
            <table
              border="1"
              class="item_table"
              style="width: 100%; border-collapse: collapse; margin-top: 20px;table-layout:fixed;"
              rules="rows"
              
            >
              <tbody
                style="width: 100%; box-sizing: border-box; text-align: center"
              >
                <tr
                  style="
                    height: 30px;
                    color: #333;
                    font-weight: 600;
                    border: solid 2px #333;
                    
                  "
                >
                  <td style="width: 330px; padding: 5px 8px">ITEMS</td>
                  <td style="width: 100px">QTY</td>
                  <td style="width: 100px">PRICE</td>
                  <td style="width: 118px; padding: 0 5px">TOTAL</td>
                </tr>
                <tr
                  v-for="(it, index) in detail.order_goods"
                  :key="index"
                  style="
                    height: 26px;
                    line-height: 26px;
                    color: #666;
                    font-weight: 400;
                    box-sizing: border-box;
                  "
                >
                  <td
                    style="
                      width: 330px;
                      padding: 5px 8px;
                      box-sizing: border-box;
                      white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
                    "
                  >
                    {{ detail.lang == 'en' ? it.goods_ename : it.goods_name }}
                  </td>
                  <td style="width: 100px;">{{ it.goods_number }}</td>
                  <td style="width: 100px;">C${{ it.goods_price }}</td>
                  <td style="width: 118px; padding: 0 5px">
                    C${{ it.total_goods_price }}
                  </td>
                </tr>
              </tbody>
            </table>
            <table
              border="1"
              class="total"
              style="
                font-size: 13px;
                width: 220px;
                margin-left: calc(100% - 220px);
                border-collapse: collapse;
                margin-top: 20px;
                border-style: dashed;
                text-align: center;
                page-break-inside : avoid;
              "
            >
              <tr>
                <td style="border-style: dashed; height: 26px">TAX</td>
                <td
                  style="border-style: dashed; height: 26px; text-align: center"
                >
                  C${{(detail.gst_amount*1 +  detail.hst_amount*1 + detail.pst_amount*1 + detail.qst_amount*1).toFixed(2)}}
                </td>
              </tr>
              <tr>
                <td style="border-style: dashed; height: 26px">SHIPPING</td>
                <td
                  style="border-style: dashed; height: 26px; text-align: center"
                >
                  C${{ detail.shipping_fee }}
                </td>
              </tr>
              <tr>
                <td style="border-style: dashed; height: 26px">DISCOUNT</td>
                <td
                  style="border-style: dashed; height: 26px; text-align: center"
                >
                  C${{ detail.goods_discount_fee }}
                </td>
              </tr>
              <tr>
                <td style="border-style: dashed; height: 26px">CREDITS</td>
                <td
                  style="border-style: dashed; height: 26px; text-align: center"
                >
                  C${{ detail.goods_wallet_fee }}
                </td>
              </tr>
              <tr style="font-weight: bold">
                <td style="border-style: dashed; height: 26px">TOTAL</td>
                <td
                  style="border-style: dashed; height: 26px; text-align: center"
                >
                  C${{ detail.order_total_amount }}
                </td>
              </tr>
            </table>
            <table
              border="1"
              class="note_table"
              style="
                border-style: dashed;
                border-collapse: collapse;
                width: 350px;
                margin: 20px 0 40px;
                font-size: 13px;
                page-break-inside : avoid;
              "
            >
              <tr>
                <td style="border-style: dashed">
                  <span
                    style="
                      width: 45px;
                      line-height: 26px;
                      display: inline-block;
                    "
                    >NOTE:</span
                  >
                </td>
              </tr>
              <tr>
                <td
                  class="buyalt"
                  style="
                    font-weight: 600;
                    border-style: dashed;
                    padding:1px 0;
                  "
                >
                  <textarea
                    style="resize: none;border: none;outline: none;width:99%;position:relative;left:0.5%;text-indent:1em;"
                    v-model="note_value"
                    :rows="4">
                  </textarea>
                </td>
              </tr>
            </table>
            <div style="text-align:center;position:fixed;bottom:5px;width:100%;left:0;" class="pageFooter">
              THANK YOU FOR YOUR PURCHASING
            </div>
          </div>
        </div>
      </el-card>
      <div style="text-align: center; margin-top: 20px">
        <el-button type="primary" style="width: 100px" @click="doPrint()">
          打印
        </el-button>
      </div>
    </el-dialog>

    <!-- 查看运单 -->
    <el-dialog title="配送单" center :visible.sync="logModel" width="500px">
      <div
        style=" text-align: center"
        v-if="logData.delivery_method == 2"
      >
        <img style="width: 100%;margin:auto;" :src="logData.carrier_waybill" alt="waybill" />
      </div>
      <el-card v-else>
        <div class="order-log"  v-if="logData.delivery_method == 5">
         <p style="width: 100%; text-align: center; font-weight: bold">
            MOOBY YOHO
          </p>
          <p class="line">
            *******************************************************************
          </p>
          <p>ORDER: {{ logData.order_no }}</p>
          <p class="line">
            *******************************************************************
          </p>
          <p>FROM: {{ logData.from }}</p>
          <p class="line">
            *******************************************************************
          </p>
          <div class="addr-box">
            <p class="addr">
              ADR: {{ logData.shops_address }}
              {{ logData.shops_city_province_zipcode }}
              {{ logData.shops_country }}
            </p>
          </div>
          <p class="line">
            *******************************************************************
          </p>
          <p>TO: {{ logData.tel }}</p>
          <p class="line">
            *******************************************************************
          </p>
          <p>TO ADR: Self Pick-Up</p>
          <p class="line">
            *******************************************************************
          </p>
          <p>Pick-Up Code: {{ logData.pick_up_code }}</p>
          <p class="line">
            *******************************************************************
          </p>
        </div>
        <div class="order-log"  v-else>
         <p style="width: 100%; text-align: center; font-weight: bold">
            MOOBY YOHO
          </p>
          <p class="line">
            *******************************************************************
          </p>
          <p>ORDER: {{ logData.order_no }}</p>
          <p class="line">
            *******************************************************************
          </p>
          <p>FROM: {{ logData.from }}</p>
          <p class="line">
            *******************************************************************
          </p>
          <div class="addr-box">
            <p class="addr">
              ADR: {{ logData.shops_address }}
              {{ logData.shops_city_province_zipcode }}
              {{ logData.shops_country }}
            </p>
          </div>
          <p class="line">
            *******************************************************************
          </p>
          <p>TO: {{ logData.to }}</p>
          <p class="line">
            *******************************************************************
          </p>
            <p>TEL: {{ logData.tel }}</p>
          <p class="line">
            *******************************************************************
          </p>
          <div class="addr-box">
            <p class="addr">
              TOADR: {{ logData.to_address }}
              {{ logData.to_city_province_zipcode }}
              {{ logData.to_country }}
            </p>
          </div>
          <p class="line">
            *******************************************************************
          </p>
        </div>
      </el-card>
      <div style="text-align: center; padding-top: 20px">
        <el-button type="success" @click="onNext()"
          >打印配送单 & 完成打包</el-button
        >
      </div>
    </el-dialog>
  </section>
</template>
<script>
import { order_detail } from "@/api/order.js";
import { logistics, print, packed, reset_choose, estimated_freight } from "@/api/warehouse.js";
import canvas from "html2canvas";
import JsPDF from "jspdf";
import { Loading } from "element-ui";
import MImg from "./../../../components/Image";
export default {
  name: "GoodsEdit",
  components: { MImg },
  data() {
    return {
      detail: {order_logistics:''},
      disabled: false,
      delivery_method: 5,
      service_id: 0,
      carrier_number: "",
      carrier_name: "",
      freight: "",
      //
      note_value: "",
      orderModel: false,
      // 配送单
      logModel: false,
      logData: {},
      // 运费价格
      freight_price: 0,
      logisticsRemarks: ''
    };
  },
  methods: {
    // 开始打印
    doPrint() {
      this.$print(this.$refs.print);
    },

    // 获取订单详情
    getDetail(id) {
      let params ={
        special: 1
      }
      order_detail(id,params).then((res) => {
        if (res) {
          this.detail = res.data;
          this.logisticsRemarks = this.detail.order_logistics.remarks
              // eShipper 请求运费价格
          if ( this.detail.is_shipping_fee == 0 && this.detail.delivery_method == 0) {
            let params = {
              logistics_id: this.detail.order_logistics.logistics_id
            }
              estimated_freight(params).then(res => {  
                  if(res){
                    this.freight_price = res.data
                    // console.log(res);
                  }
              })
          }
          this.detail_modal = true;
          if (this.detail.delivery_method == 1) {
            this.delivery_method = 5;
          } else {
            this.delivery_method = 1;
          }
          if(res.data.order_logistics.delivery_method == 0) {
            this.delivery_method = 1
          } else {
            this.delivery_method = res.data.order_logistics.delivery_method
          }
          
          // this.$nextTick(() => {
          //   this.orderImgInit();
          // });
        }
      });
    },
    resetConfirm() {
      this.$confirm(`当前订单的运输物流是否选择重置？`, "确认物流", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let params = {
          order_id: this.$route.params.id,
        }
        reset_choose(params).then(res => {  
            if(res){
              this.getDetail(this.$route.params.id);
                this.$message.success(res.msg)
            }
        })
      });
    },
    // 确认订单物流
    onConfirm() {
      let params = {
        order_id: this.$route.params.id,
        delivery_method: this.delivery_method,
        remarks: this.logisticsRemarks
      };

      console.log(this.delivery_method);

      // if (this.delivery_method != 5) {
      //   this.$message.error("请先选择物流");
      //   return false;
      // }

      if (this.delivery_method == 2) {
        params.service_id = this.detail.order_logistics.service_id;
      }
      if (this.delivery_method == 3) {
        if (
          this.carrier_number == "" ||
          this.carrier_name == "" ||
          this.freight == "" ||
          this.logisticsRemarks == ""
        ) {
          this.$message.error("请完善其他物流信息");
          return false;
        } else {
          params.carrier_number = this.carrier_number;
          params.carrier_name = this.carrier_name;
          params.freight = this.freight;
        }
      }

      this.$confirm(`当前订单的运输物流是否选择正确？`, "确认物流", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.disabled = true;
        logistics(params)
          .then((res) => {
            if (res) {
              this.getDetail(this.$route.params.id);
              this.$message({ message: res.msg, type: "success", offset: 200 });
            }
          })
          .finally(() => {
            this.disabled = false;
          });
      });
    },

    // 查看运单
    onPrint() {
      print(this.$route.params.id).then((res) => {
        if (res) {
          console.log(res.data);
          this.logData = res.data;
          this.logModel = true;
        }
      });
    },

    // 打印配送单 处理下一单
    onNext() {
      this.disabled = true;
      packed(this.$route.params.id)
        .then((res) => {
          if (res) {
            this.logModel  = false;
            this.$message({ message: res.msg, type: "success", offset: 200 });
            this.$router.go(-1);
          }
        })
        .finally(() => {
          this.disabled = false;
        });
    },

    // 打印订单详情
    onOrder() {
      this.orderModel = true;
    },

    // 生成订单详情图片
    orderImgInit() {
      let that = this;
      let loading = Loading.service({
        // 这里添加了loading效果
        lock: true,
        text: "正在生成pdf...",
        background: "rgba(0,0,0,.5)",
      });
      canvas(document.querySelector("#order")).then(function (canvas) {
        //延迟执行确保万无一失，玄学
        var timer = setTimeout(() => {
          var imgData = canvas.toDataURL("image/png"); //canvas转换为图片
          that.orderUrl = imgData;
          let contentWidth = 870;
          let contentHeight = 1000;
          if (
            contentWidth === "" ||
            contentWidth === undefined ||
            contentHeight === "" ||
            contentHeight === undefined
          ) {
            // 判断是否转换失败
            loading.close();
            that.$message.error("转换pdf失败，请稍后再试！");
          }
          let pageHeight = (contentWidth / 595) * 842;
          let leftHeight = contentHeight;
          let position = 0;
          let imgWidth = 595;
          let imgHeight = (595 / contentWidth) * contentHeight;
          let PDF = new JsPDF("", "pt", "a4");
          if (leftHeight < pageHeight) {
            PDF.addImage(imgData, "JPEG", 0, 0, imgWidth, imgHeight);
          } else {
            while (leftHeight > 0) {
              PDF.addImage(imgData, "JPEG", 0, position, imgWidth, imgHeight);
              leftHeight -= pageHeight;
              position -= 842;
              if (leftHeight > 0) {
                PDF.addPage();
              }
            }
          }
          loading.close(); // 关闭loading效果
          // PDF.save(that.detail.title);
          clearTimeout(timer);
        }, 0);
      });
    },
  },

  created() {
    this.getDetail(this.$route.params.id);
  },
  activated() {
     this.getDetail(this.$route.params.id);
  }
};
</script>


<style lang="less" scoped>
@page {
  size: auto A4 landscape;
  margin: 3mm; 
}
@media print {
    html {
      zoom: 100%;
    }
}
section {
  .pageFooter {
    display: none;
  }
  .top-flex {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .row-height {
    height: 40px;
    line-height: 40px;
    .row-span + .row-span {
      margin-left: 20px;
    }
  }
  .col-label {
    min-width: 85px;
  }
  .distanceLeft {
    margin-left: 10px;
  }
  .order-log {
    width: 350px;
    margin: 0 auto;
    > p {
      height: 40px;
      line-height: 40px;
      overflow: hidden;
    }
    .line {
      height: 20px;
      line-height: 20px;
    }
    .addr-box {
      height: 40px;
      display: flex;
      align-items: center;
    }
    .addr {
      line-height: 20px;
    }
  }
  .remarks {
    position: absolute;
    top: 20px;
    right: 50px;
    .remarks-inp {
      display: flex;
      span {
        width: 100px;
        height: 40px;
        line-height: 40px;
      }
    }
  }
  /deep/ .el-textarea.is-disabled .el-textarea__inner {
    background-color:#fff;
    color: rgb(3, 97, 192);
    cursor: default;
    width: 250px;
  }
}
</style>

